import { PulseStorage } from '@pulse/common';
import { Subject } from 'rxjs';

export class TransientStorage extends PulseStorage {
    private db = new Map<string, string>();
    freeSpace$: Subject<void> = new Subject();

    constructor() {
        super({ storagePrefix: '' });
    }

    get(key: string): string | null {
        return this.db.get(key) ?? null;
    }

    set(key: string, value: string, asExternal = false): void {
        this.db.set(key, value);
        this.emitChange({ key, value, external: asExternal });
    }

    keys(): string[] {
        return Array.from(this.db.keys());
    }

    remove(key: string): void {
        this.db.delete(key);
        this.emitChange({ key, value: null, external: false });
    }

    clear() {
        this.db = new Map();
    }

    all(): Record<string, string> {
        return Array.from(this.db.entries()).reduce<Record<string, string>>(
            (data, [key, value]) => {
                data[key] = value;

                return data;
            },
            {},
        );
    }
}
